import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(1),
    marginBottom: theme.spacing(3),
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      margin: "initial",
      width: "100%",
      flexWrap: "wrap",
      justifyContent: "center",
      textAlign: "center",
    },
  },
  autocomplete: {
    height: "29px",
    borderRadius: "5px",
  },
  leftContainer: {
    width: "40%",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      order: 1,
      width: "100%",
      justifyContent: "center",
      marginBottom: "20px",
      marginRight: "initial",
    },
  },
  middleContainer: {
    width: "40%",
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      order: 2,
      width: "100%",
      justifyContent: "center",
      marginBottom: "20px",
      marginRight: "initial",
    },
  },
  rightContainer: {
    width: "20%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "35%",
    },
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "row",
      order: 0,
      width: "100%",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
  },
  idContainer: {
    [theme.breakpoints.down("xs")]: {
      width: "30%",
    },
  },
  dateContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      marginTop: "initial",
      width: "50%",
    },
  },
  textfield: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  pickerInput: {
    // "&.MuiOutlinedInput-adornedEnd": {
    paddingRight: 0,
  },
}))

export default styles
